import React from 'react';
import { useNavigate } from 'react-router-dom';

export const ClickableTableLink = ({ path, displayValue, searchValue, role, date }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (!path ) return;

        const yearNum = Number(date);
    const years = yearNum ? [yearNum - 1, yearNum, yearNum + 1] : [];

        navigate(path, {
            state: { search: searchValue, role: role, years:years, months:[4,5,6,7,8,9,10,11,12,1,2,3] },
        });
    };

    return (
        <span
            onClick={handleClick}
            className="text-sky-700 font-medium cursor-pointer underline decoration-sky-700/30 decoration-1 underline-offset-4 hover:text-sky-900 hover:decoration-sky-900 transition-colors duration-150"
            style={{ display: 'inline-block' }}
        >
            {displayValue || '—'}
        </span>
    );
};